<template>
	<div class="mainWrapper products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export PO</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/direct-purchase">
					Back to Direct Purchase List
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brands (Optional)"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>
			<div>
				<b-datepicker :date-formatter="dateFormatter" placeholder="Starting Date" v-model="startingDate" icon="calendar-today">
					<button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button>
				</b-datepicker>
			</div>

			<div>
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Ending Date"
					v-model="endingDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
				>
					<button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</div>

			<div>
				<b-button type="is-info" @click="exportDP()">Export</b-button>
			</div>
		</div>

		<div v-if="progress > 0">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Products',
	data: function() {
		return {
			limit: 20,
			isLoading: false,
			brands: [], // To store brands
			allBrands: [],
			selectedBrand: null,
			brandSuggestions: '',
			dp: [],
			exportPo: [],
			totalLoop: 0,
			progress: 0,
			startingDate: null,
			endingDate: null,
			minDate: null,
			maxDate: null
		}
	},

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getBrands()

		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		exportDP: async function() {
			// Set default data
			this.dp = []
			this.exportPo = []

			this.totalLoop = 0
			this.progress = 0

			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Starting and ending dates are required'
				})

				return
			}

			this.isLoading = true

			// To filter with start and end date
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.startingDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.endingDate)
				.set({ hour: 24 })
				.format('x')

			// Set parameters for API
			var data = {
				limit: 1,
				time: {
					createdAt
				}
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			const apiGetPO = await this.$api.getDP({ data })

			// Loop to get all data
			if (apiGetPO) {
				const total = apiGetPO.data.total
				const totalLoop = Math.ceil(apiGetPO.data.total / this.limit)

				this.totalLoop = total

				var i

				for (i = 0; i < totalLoop; i++) {
					const skip = i * this.limit

					const result = await this.getDP(skip)

					result.map(item => {
						this.dp.push(item)
					})
				}

				this.progress = 100
			} else {
				this.$swal.fire({
					icon: 'info',
					title: 'No Data...',
					text: 'Sorry, no data found'
				})

				this.isLoading = false

				return
			}

			if (this.dp.length > 0) {
				for (let result in this.dp) {
					let direct_purchase = this.dp[result]._id

					this.dp[result].detail = []
					this.dp[result].products = []

					var data = {
						id: direct_purchase,
						populate_direct_purchase: ['author'],
						populate_direct_purchase_item: ['product']
					}

					const apiGetDPDetail = await this.$api.getDPDetail({ data })

					this.dp[result].detail = apiGetDPDetail.data.direct_purchase
					this.dp[result].products = apiGetDPDetail.data.direct_purchase_items

					// this.dp[result].products =

					// if (apiGetDPDetail !== undefined) {
					// 	if (this.selectedBrand) {
					// 		if (apiGetDPDetail.data.count > 0 && apiGetDPDetail.data.list[0].product.brand == this.selectedBrand._id) {
					// 			this.matchFound = true

					// 			apiGetDPDetail.data.list.map(dpItem => {
					// 				this.dp[result].products.push(dpItem)
					// 			})
					// 		}
					// 	} else {
					// 		apiGetDPDetail.data.list.map(dpItem => {
					// 			this.dp[result].products.push(dpItem)
					// 		})
					// 	}
					// }
				}
			}

			if (this.dp.length > 0) {
				// console.log(this.dp)
				this.generateCSV()
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Nothing found!'
				})
			}
		},

		generateCSV: function() {
			let export_csv = ''

			// Loop data
			this.dp.map(data => {
				if (data.products.length > 0) {
					export_csv += 'DP CODE,DATE,TIME,BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,BRANCH,ADMIN NAME,DATE,QUANTITY,PRICE,NET AMOUNT,REMARK\r\n'

					let total_quantity = 0
					let total_amount = 0

					// Map all the transfer products
					data.products.map(items => {
						let matchedBrand = this.brands.filter(brand => {
							return brand._id == items.product.brand
						})

						const product_price =
							items.product.commission > 0 || items.product.original_price < 2 ? items.product.price : items.product.original_price

						const dest_name = data.shop ? data.shop.name : data.author.name

						const toAdd = [
							data.code,
							this.$moment(items.createdAt).format('DD/MM/YY'),
							this.$moment(items.createdAt).format('hh:mm a'),
							items.product.bd_code,
							items.product.barcode,
							'"' + items.product.name + '"',
							matchedBrand[0].name,
							matchedBrand[0].code,
							// data.shop.name,
							dest_name,
							data.author.name,
							this.$moment(data.createdAt).format('DD/MM/YY hh:mm a'),
							items.qty,
							product_price,
							product_price * items.qty,
							items.remark
						]

						total_quantity += items.qty
						total_amount += product_price * items.qty

						let row = toAdd.join(',')

						export_csv += row + '\r\n'
					})

					export_csv += ',,,,,,,,,,Total,' + total_quantity + ',,' + total_amount

					export_csv += '\r\n\r\n'
				}
			})

			this.isLoading = false

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Direct_Purchase_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.returnNumber = null
		},

		getDP: async function(skip = 0) {
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.startingDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.endingDate)
				.set({ hour: 24 })
				.format('x')

			// Set parameters for API
			var data = {
				limit: this.limit,
				populate: ['author'],
				time: {
					createdAt
				}
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			const apiGetPO = await this.$api.getDP({ data })

			return apiGetPO.data.list
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.allBrands = apiGetBrands.data.list
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/Products.css';
</style>
